import { personExtendedInfoFrag } from '../../../../../utils/type/person.common-type';
import { userInfoFrag } from '../../../../../utils/type/user.common-type';

export const toolMissingProceduresFrag = `
    id
    date
    folder {
        id
        personId
        serviceId
        status
        person {
            ${personExtendedInfoFrag}
        }
        createdAt
        closedAt
        activeGroups {
            id
            group {
              id
              name
            }
        }
        anamnesis {
            dateFrom
            dateTo
            doctor {
                ${userInfoFrag}
            }
        }
        activeGroups {
            group {
                name
            }
        }
    }
    works {
        id
        workType
        dateFrom
        users {
            ${userInfoFrag}
        }
    }
`;
